// Mirrors the icon and theme choices the API accepts (and the mobile app offers).
export const roomIcons: { id: string; glyph: string; label: string }[] = [
  { id: 'film', glyph: '🎬', label: 'Film' },
  { id: 'sparkles', glyph: '✨', label: 'Sparkles' },
  { id: 'moon', glyph: '🌙', label: 'Late night' },
  { id: 'rocket', glyph: '🚀', label: 'Rocket' },
  { id: 'skull', glyph: '💀', label: 'Horror' },
  { id: 'fast-food', glyph: '🍿', label: 'Snacks' },
];

export const roomThemes: Record<string, string> = { violet: '#7657ff', ocean: '#2785c7', sunset: '#d76552', forest: '#3c9a71', gold: '#c49335' };

export const roomGlyph = (icon?: string) => roomIcons.find(item => item.id === icon)?.glyph || '🎬';
export const roomColour = (theme?: string) => roomThemes[theme || 'violet'] || roomThemes.violet;
export const roomTitle = (room: any) => room?.roomName || room?.partnerName || 'Film room';
